var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RDbImpl, RSchemaImpl, RTableGroupImpl, deriveRowId, } from "@hyper-hyper-space/hhs3_rdb";
import { columnSetFromTableDecl, columnsOfFromTableDecls, columnsOfFromSchemaView, } from "./rule_scope.js";
import { lowerRestrictionPredicate } from "./query.js";
export function compileCreate(bound) {
    return __awaiter(this, void 0, void 0, function* () {
        if (bound.kind === 'create-database')
            return compileCreateDatabase(bound);
        if (bound.kind === 'create-schema')
            return compileCreateSchema(bound);
        return compileCreateTableGroup(bound);
    });
}
function compileCreateDatabase(bound) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = yield RDbImpl.create(Object.assign({ seed: bound.seed, name: bound.ast.name }, (bound.creators.length > 0 ? { creators: bound.creators } : {})));
        return { kind: 'create-database', name: bound.ast.name, payload };
    });
}
function compileCreateSchema(bound) {
    return __awaiter(this, void 0, void 0, function* () {
        const columnsOf = columnsOfFromTableDecls(bound.ast.tables);
        const payload = yield RSchemaImpl.create({
            name: bound.ast.name,
            creators: bound.creators,
            tables: bound.ast.tables.map((table) => compileTable(table, {
                gated: { name: table.name, columns: columnSetFromTableDecl(table) },
                columnsOf,
            })),
        });
        return { kind: 'create-schema', name: bound.ast.name, payload };
    });
}
function compileCreateTableGroup(bound) {
    return __awaiter(this, void 0, void 0, function* () {
        const initialRows = {};
        for (const row of bound.initialRows) {
            const payload = {
                action: 'insert',
                rowId: deriveRowId(row.uuid),
                uuid: row.uuid,
                values: row.values,
            };
            if (initialRows[row.table] === undefined)
                initialRows[row.table] = [];
            initialRows[row.table].push(payload);
        }
        let columnsOf = columnsOfFromTableDecls([]);
        if (bound.schema.schema !== undefined) {
            const view = yield bound.schema.schema.getView(bound.schemaVersion, bound.schemaVersion);
            columnsOf = columnsOfFromSchemaView(view);
        }
        const gateScope = { columnsOf };
        const canObserve = {};
        for (const clause of bound.ast.canObserve) {
            canObserve[clause.binding] = lowerRestrictionPredicate(clause.predicate, gateScope);
        }
        const payload = yield RTableGroupImpl.create(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ name: bound.ast.name, seed: bound.seed, schemaRef: bound.schema.id, schemaVersion: bound.schemaVersion }, (Object.keys(bound.bindings).length > 0 ? { bindings: bound.bindings } : {})), (bound.ast.idProvider !== undefined ? { idProvider: bound.ast.idProvider } : {})), (bound.ast.canDeploy !== undefined ? { canDeploy: lowerRestrictionPredicate(bound.ast.canDeploy, gateScope) } : {})), (bound.ast.canObserve.length > 0 ? { canObserve } : {})), (Object.keys(initialRows).length > 0 ? { initialRows } : {})));
        return { kind: 'create-tablegroup', name: bound.ast.name, payload };
    });
}
export function compileTable(table, scope) {
    const columns = {};
    const fks = {};
    const restrictions = [];
    let concurrentDeletes;
    let idProvider;
    for (const column of table.columns) {
        columns[column.name] = compileColumn(column);
        if (column.references !== undefined)
            fks[column.name] = column.references;
    }
    const ruleScope = scope !== null && scope !== void 0 ? scope : {
        gated: { name: table.name, columns: columnSetFromTableDecl(table) },
        columnsOf: columnsOfFromTableDecls([table]),
    };
    for (const option of table.options) {
        switch (option.kind) {
            case 'concurrent-deletes':
                concurrentDeletes = option.value;
                break;
            case 'identity-provider':
                idProvider = { keyIdColumn: option.keyIdColumn, publicKeyColumn: option.publicKeyColumn };
                break;
            case 'allow-rule':
                restrictions.push({ on: option.op, rule: lowerRestrictionPredicate(option.predicate, ruleScope) });
                break;
        }
    }
    const def = { name: table.name, columns };
    if (Object.keys(fks).length > 0)
        def.fks = fks;
    if (restrictions.length > 0)
        def.restrictions = restrictions;
    if (concurrentDeletes !== undefined)
        def.concurrentDeletes = concurrentDeletes;
    if (idProvider !== undefined)
        def.idProvider = idProvider;
    return def;
}
export function compileColumn(column) {
    const def = { type: column.type };
    if (column.nullable)
        def.nullable = true;
    if (column.defaultValue !== undefined) {
        if (column.defaultValue.kind !== 'literal')
            throw new Error('column DEFAULT must be a literal');
        if (column.defaultValue.value === null)
            throw new Error('column DEFAULT NULL is not supported by RDb json.Literal payloads');
        def.default = column.defaultValue.value;
    }
    if (column.pub)
        def.pub = true;
    if (column.readonly)
        def.readonly = true;
    return def;
}
